import React, { useState } from 'react';
import { DatePicker, Space, Dropdown, Menu, Input } from 'antd';
import {
  EyeInvisibleOutlined,
  EyeTwoTone,
  SearchOutlined
} from '@ant-design/icons';

interface Props {
  handleInputValue: Function;
}

const { Search } = Input;

function SearchInput({ handleInputValue }: Props) {
  const [input, setInput] = useState('');
  handleInputValue(input);
  return (
    <Space direction="vertical" className="busk-seacrhSeller">
      <Search
        placeholder="검색"
        suffix={<SearchOutlined />}
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
        }}
      />
    </Space>
  );
}

export default SearchInput;
